export default __webpack_public_path__ + "static/media/nodeBW.25593c70.webp";